import { driver } from 'driver.js';
import 'driver.js/dist/driver.css';
import { useTranslation } from 'react-i18next';
import { useCallback } from 'react';

/**
 * Hook to create a guided tour for the Users (Mships) page
 * Uses Driver.js to highlight elements and show explanations
 */
export function useMshipsTour() {
    const { t } = useTranslation();

    const startTour = useCallback(() => {
        const driverObj = driver({
            showProgress: true,
            animate: true,
            allowClose: true,
            stagePadding: 4,
            nextBtnText: t('tour.next'),
            prevBtnText: t('tour.back'),
            doneBtnText: t('tour.last'),
            progressText: '{{current}} / {{total}}',
            steps: [
                {
                    popover: {
                        title: t('tour.mships.intro.title'),
                        description: t('tour.mships.intro.description'),
                    },
                },
                {
                    element: '#fab-add-button',
                    popover: {
                        title: t('tour.mships.addButton.title'),
                        description: t('tour.mships.addButton.description'),
                        side: 'top',
                        align: 'end',
                    },
                },
                {
                    element: 'table tbody tr td:nth-child(2) a',
                    popover: {
                        title: t('tour.mships.userName.title'),
                        description: t('tour.mships.userName.description'),
                        side: 'bottom',
                        align: 'start',
                    },
                },
                {
                    element: 'input[type="text"]',
                    popover: {
                        title: t('tour.mships.searchFilter.title'),
                        description: t('tour.mships.searchFilter.description'),
                        side: 'bottom',
                        align: 'start',
                    },
                },
                {
                    element: '#filter-button',
                    popover: {
                        title: t('tour.mships.filterButton.title'),
                        description: t('tour.mships.filterButton.description'),
                        side: 'bottom',
                        align: 'end',
                    },
                },
            ],
        });

        driverObj.drive();
    }, [t]);

    return { startTour };
}
